import Vue from 'vue'
import Vuec from 'vue-container'
import Vuex from 'vuex'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import VueResize from 'vue-resize'
import VueClipboard from 'vue-clipboard2'
import VueDebounce from 'vue-debounce'
import VueToExcel from 'vue-json-excel'

import App from './App'
import store from './store'
import router from './router'
import ApiService from './service/ApiService'
import RoleGroupsService from './service/RoleGroupsService';
import SubscriberService from './service/SubscriberService'
import ChannelService from './service/ChannelService'
import PackageService from './service/PackageService'
import DeviceService from './service/DeviceService'
import PairingCodeService from './service/PairingCodeService'
import BillerService from './service/BillerService'
import LanguageListService from "./service/LanguageListService";
import UserService from './service/UserService'
import OperatorService from './service/OperatorService'
import ServiceService from './service/ServiceService'
import ServiceWeightCategoryService from './service/ServiceWeightCategoryService'
import DownloadService from './service/DownloadService'
import BusinessModelService from './service/BusinessModelService'
import ContentSourceService from './service/ContentSourceService'
import ContentSourceContentService from './service/ContentSourceContentService'
import ContentSourceMaintenanceWindowService from './service/ContentSourceMaintenaceWindowService'
import ProtocolService from './service/ProtocolService'
import LocalityService from './service/LocalityService'
import UrlTemplateService from './service/UrlTemplateService'
import ContentSourceNonlinearContentSettingsService from './service/ContentSourceNonlinearContentSettingsService'
import ReportsService from "./service/ReportsService"
import ReportsOperatorService from "./service/ReportsOperatorService"
import CronService from "./service/CronService"
import MessageTemplateService from "./service/MessageTemplateService"
import MessageService from "./service/MessageService"
import RequestLogService from "@/service/RequestLogService"
import ErrorLogService from "@/service/ErrorLogService"
import OptimizationService from "@/service/OptimizationService"
import BrandService from "@/service/BrandService"
import CodecService from "@/service/CodecService"
import DeviceTypeService from "./service/DeviceTypeService";
import DeviceTypeEvaluationService from "./service/DeviceTypeEvaluationService";
import StreamProfileService from "./service/StreamProfileService";
import PvrService from "./service/PvrService";
import FavoriteShowService from "./service/FavoriteShowService";
import PeriodicPvrService from "./service/PeriodicPvrService";
import ChannelGroupService from "./service/ChannelGroupService";
import OperatorTagService from "./service/OperatorTagService";
import CustomExportService from "./service/CustomExportService";
import DashboardCarouselService from "./service/DashboardCarouselService";
import RegisteredMacAddressBatchService from "./service/RegisteredMacAddressBatchService";
import RegisteredMacAddressService from "./service/RegisteredMacAddressService";
import UnregisteredMacAddressService from "./service/UnregisteredMacAddressService";
import VersionRedirectService from "./service/VersionRedirectService";
import GeoblockingPrivateIpService from "./service/GeoblockingPrivateIpService";
import AdvertisingBannerService from "./service/AdvertisingBannerService";
import AdvertisingBannerRecipientService from  "./service/AdvertisingBannerRecipientService";
import SubscriberProfileService from "./service/SubscriberProfileService";
import ThematicGroupService from "./service/ThematicGroupService";
import InitialProcessSetupService from "./service/InitialProcessSetupService";
import BlackoutContentsService from './service/BlackoutContentService'
import MaturityRatingService from "./service/MaturityRatingService";
import EpgCacheService from "./service/EpgCacheService";
import AdvertisingProviderService from "./service/AdvertisingProviderService";
import AdvertisingProviderChannelGroupService from "./service/AdvertisingProviderChannelGroupService";
import LandingPageService from "./service/LandingPageService";
import SubscriberNotificationService from "./service/SubscriberNotificationService";
import ImageService from "./service/ImageService";

import './globalComponents'

import './assets/css/main.css'
import 'vue-resize/dist/vue-resize.css'
import {AUTH_LOGOUT} from "@/store/mutation-types"
import './assets/js/jquery.responsiveTabs';
import './assets/js/custom.js';
import './assets/js/tables.js';
import './assets/js/select2.full.min';

// registering mixins globally
import date from './components/mixins/global/date'
import loggedUser from './components/mixins/global/logged-user'
import env from './components/mixins/global/env'
import {$_getApiHost} from './components/mixins/global/env'

import GetTextPlugin from 'vue-gettext'
import translations from '../resources/translations.json'
import TagService from "./service/TagService";
import BrandDomainService from "./service/BrandDomainService";
import AdminConfigurationService from "./service/AdminConfigurationService";
import DeviceProfileService from "./service/DeviceProfileService";
import DeviceConfigService from "./service/DeviceConfigService";
import VodProviderService from "./service/VodProviderService";
import VodVideoService from "./service/VodVideoService";
import VodPackageService from "./service/VodPackageService";
import VodEpisodeService from "./service/VodEpisodeService";
import CurrencyService from "./service/CurrencyService";
import DeviceBootConfigService from "./service/DeviceBootConfigService";

Vue.use(GetTextPlugin, {
	availableLanguages: {
		CS: 'CS',
		EN: 'EN',
		DE: 'DE',
		SK: 'SK',
	},
	defaultLanguage: localStorage.getItem('language') ? localStorage.getItem('language') : 'CS',
	translations: translations,
	silent: true,
})

Vue.filter('translate', value => {
	return !value
		? ''
		: Vue.prototype.$gettext(value.toString())
})

Vue.mixin(date)
Vue.mixin(loggedUser)
Vue.mixin(env)

Vue.use(Vuec)
Vue.use(Vuex)
Vue.use(VueResize)
Vue.use(VueLodash, lodash)
Vue.use(VueClipboard)
Vue.use(VueDebounce, {
	defaultTime: '700ms'
})
Vue.component('export-excel', VueToExcel)

const apiService = new ApiService($_getApiHost() +'/ui/', Vue)
Vue.$ioc.register('AdminConfigurationService', new AdminConfigurationService(apiService))
Vue.$ioc.register('RoleGroupsService', new RoleGroupsService(apiService));
Vue.$ioc.register('SubscriberService', new SubscriberService(apiService))
Vue.$ioc.register('ChannelService', new ChannelService(apiService))
Vue.$ioc.register('PackageService', new PackageService(apiService))
Vue.$ioc.register('DeviceService', new DeviceService(apiService))
Vue.$ioc.register('PairingCodeService', new PairingCodeService(apiService))
Vue.$ioc.register('BillerService', new BillerService(apiService))
Vue.$ioc.register('LanguageListService', new LanguageListService(apiService))
Vue.$ioc.register('UserService', new UserService(apiService))
Vue.$ioc.register('OperatorService', new OperatorService(apiService))
Vue.$ioc.register('ServiceService', new ServiceService(apiService))
Vue.$ioc.register('ServiceWeightCategoryService', new ServiceWeightCategoryService(apiService))
Vue.$ioc.register('DownloadService', new DownloadService(apiService))
Vue.$ioc.register('BusinessModelService', new BusinessModelService(apiService))
Vue.$ioc.register('ContentSourceService', new ContentSourceService(apiService))
Vue.$ioc.register('ContentSourceContentService', new ContentSourceContentService(apiService))
Vue.$ioc.register('ContentSourceMaintenanceWindowService', new ContentSourceMaintenanceWindowService(apiService))
Vue.$ioc.register('ProtocolService', new ProtocolService(apiService))
Vue.$ioc.register('LocalityService', new LocalityService(apiService))
Vue.$ioc.register('UrlTemplateService', new UrlTemplateService(apiService))
Vue.$ioc.register('ContentSourceNonlinearContentSettingsService', new ContentSourceNonlinearContentSettingsService(apiService))
Vue.$ioc.register('ReportsService', new ReportsService(apiService))
Vue.$ioc.register('ReportsOperatorService', new ReportsOperatorService(apiService))
Vue.$ioc.register('CronService', new CronService(apiService))
Vue.$ioc.register('MessageTemplateService', new MessageTemplateService(apiService))
Vue.$ioc.register('MessageService', new MessageService(apiService))
Vue.$ioc.register('RequestLogService', new RequestLogService(apiService))
Vue.$ioc.register('ErrorLogService', new ErrorLogService(apiService))
Vue.$ioc.register('OptimizationService', new OptimizationService(apiService))
Vue.$ioc.register('TagService', new TagService(apiService))
Vue.$ioc.register('OperatorTagService', new OperatorTagService(apiService))
Vue.$ioc.register('BrandService', new BrandService(apiService))
Vue.$ioc.register('CodecService', new CodecService(apiService))
Vue.$ioc.register('DeviceTypeService', new DeviceTypeService(apiService))
Vue.$ioc.register('DeviceTypeEvaluationService', new DeviceTypeEvaluationService(apiService))
Vue.$ioc.register('DeviceProfileService', new DeviceProfileService(apiService))
Vue.$ioc.register('DeviceConfigService', new DeviceConfigService(apiService))
Vue.$ioc.register('BrandDomainService', new BrandDomainService(apiService))
Vue.$ioc.register('StreamProfileService', new StreamProfileService(apiService))
Vue.$ioc.register('PvrService', new PvrService(apiService))
Vue.$ioc.register('FavoriteShowService', new FavoriteShowService(apiService))
Vue.$ioc.register('PeriodicPvrService', new PeriodicPvrService(apiService))
Vue.$ioc.register('ChannelGroupService', new ChannelGroupService(apiService))
Vue.$ioc.register('CustomExportService', new CustomExportService(apiService))
Vue.$ioc.register('DashboardCarouselService', new DashboardCarouselService(apiService))
Vue.$ioc.register('RegisteredMacAddressBatchService', new RegisteredMacAddressBatchService(apiService))
Vue.$ioc.register('RegisteredMacAddressService', new RegisteredMacAddressService(apiService))
Vue.$ioc.register('UnregisteredMacAddressService', new UnregisteredMacAddressService(apiService))
Vue.$ioc.register('VersionRedirectService', new VersionRedirectService(apiService))
Vue.$ioc.register('GeoblockingPrivateIpService', new GeoblockingPrivateIpService(apiService))
Vue.$ioc.register('AdvertisingBannerService', new AdvertisingBannerService(apiService))
Vue.$ioc.register('AdvertisingBannerRecipientService', new AdvertisingBannerRecipientService(apiService))
Vue.$ioc.register('SubscriberProfileService', new SubscriberProfileService(apiService))
Vue.$ioc.register('ThematicGroupService', new ThematicGroupService(apiService))
Vue.$ioc.register('InitialProcessSetupService', new InitialProcessSetupService(apiService))
Vue.$ioc.register('BlackoutContentService', new BlackoutContentsService(apiService))
Vue.$ioc.register('MaturityRatingService', new MaturityRatingService(apiService))
Vue.$ioc.register('EpgCacheService', new EpgCacheService(apiService))
Vue.$ioc.register('VodProviderService', new VodProviderService(apiService))
Vue.$ioc.register('VodPackageService', new VodPackageService(apiService))
Vue.$ioc.register('VodVideoService', new VodVideoService(apiService))
Vue.$ioc.register('VodEpisodeService', new VodEpisodeService(apiService))
Vue.$ioc.register('CurrencyService', new CurrencyService(apiService))
Vue.$ioc.register('AdvertisingProviderService', new AdvertisingProviderService(apiService))
Vue.$ioc.register('AdvertisingProviderChannelGroupService', new AdvertisingProviderChannelGroupService(apiService))
Vue.$ioc.register('DeviceBootConfigService', new DeviceBootConfigService(apiService))
Vue.$ioc.register('LandingPageService', new LandingPageService(apiService))
Vue.$ioc.register('SubscriberNotificationService', new SubscriberNotificationService(apiService))
Vue.$ioc.register('ImageService', new ImageService(apiService))

// keep alive - every 10 minutes
setInterval(function () {
	if (store.getters.isAuthenticated) {
		if (apiService.keepAlive() > 18) {
			store.dispatch(AUTH_LOGOUT)
				.then(() => {
					router.push({name: 'login'})
				})
		}
	}
}, 1000 * 60 * 10)

let isProduction = process.env.NODE_ENV === 'production';

Vue.config.devtools = !isProduction;
Vue.config.performance = !isProduction;

global.vm = new Vue({
	el: '#main',
	store,
	router,
	template: '<App/>',
	components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js